import React, { Fragment } from "react";
import MpgItem from "../../../CommonFormComp/MpgItem";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import MpgInput from "../../../CommonFormComp/MpgInput";

const AdminUserProfileSection = ({
  rhfFormInstance,
  fetchAdminUserProfileLabel,
  adminUserCMSData,
}) => (
  <Fragment>
    <MpgItem sx={{ padding: { xs: "20px" } }}>
      <Typography
        variant="h6"
        align="center"
        sx={{ fontWeight: "bolder" }}
      >
        {adminUserCMSData?.pageContent["AdminUserProfile"]?.Title}
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={6}>
          <MpgInput
            rhfFormInstance={rhfFormInstance}
            name={"bio_user_profile"}
            label={fetchAdminUserProfileLabel("AdminUserProfile.Bio")}
            fullWidth
            multiline={true}
            rows={4}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <MpgInput
            rhfFormInstance={rhfFormInstance}
            name={"expertise"}
            label={fetchAdminUserProfileLabel("AdminUserProfile.Expertise")}
            fullWidth
            multiline={true}
            rows={4}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <MpgInput
            rhfFormInstance={rhfFormInstance}
            name={"linkedIn_id"}
            label={fetchAdminUserProfileLabel("AdminUserProfile.LinkedInID")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <MpgInput
            rhfFormInstance={rhfFormInstance}
            name={"twitter_id"}
            label={fetchAdminUserProfileLabel("AdminUserProfile.TwitterID")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <MpgInput
            rhfFormInstance={rhfFormInstance}
            name={"language_user_profile"}
            label={fetchAdminUserProfileLabel("AdminUserProfile.Language")}
            fullWidth
          />
        </Grid>
      </Grid>
    </MpgItem>
    <br />
  </Fragment>
);

export default AdminUserProfileSection;